import React,{useRef, useState, useEffect} from "react";
import { Link, useParams, useLocation } from "react-router-dom";
import { Col, Row, Form, Nav, Card, Button, Badge, InputGroup, Spinner  } from "react-bootstrap";
import {setUrlParam } from "../utils/functions";
import Select from "react-select";
import Footer from "../layouts/Footer";
import Sidebar from "../layouts/Sidebar";
import Header from "../layouts/Header";
import parse from 'html-react-parser';
import {projectPhaseColors} from "../data/ProjectStatusColor";
import Country from "../classes/Country";
import vindrApi from "../utils/vindrapi";
import authApi from "../utils/authApi";
import Loader from "../components/Loader";
import Filter from "../components/Filter";
import SearchOwner from "../components/SearchOwner";
import UserMenu		from "../components/UserMenu";

//import mapboxgl from '!mapbox-gl'; // eslint-disable-line import/no-webpack-loader-syntax
 
//mapboxgl.accessToken = 'pk.eyJ1IjoiZXNwZW52aW5kciIsImEiOiJjbGZpOXoyamIyYW1wM3FuMXBidjlvcXl5In0.XDmLF8QmTyYR-PiDcnDFGQ';


export default function LandOwners() {

	const [pageTitle,setPageTitle]		= useState('List of Owners');
	const location = useLocation();
	const params = new URLSearchParams(location.search);
	
	document.body.className="owners";
	
	var countrySel		= params.get("country") ? params.get("country").split(",")	: [];
	var lastCall;
	/*
	options of the sort by select box
	*/
	const ownersSortOptions = [
		{label:"Name", value:"name"},
		{label:"Email", value:"email"}
	];
	
	const [orderBy, setOrder]					= useState('');
	const [needle, setNeedle]					= useState('');
	const [data,setOwners]						= useState([]);
	const [user,setUser]						= useState({});
	const [showFilters,setShowFilters]			= useState(false);
	const [pending,setPending]					= useState(true); //status variable set when all data is loaded
	const [filterCountry, setFilterCountry]			= useState(new Set(countrySel));
	
	
	
	const countryComp = React.createRef();
	
	
	const getData = ()=>{ 
		

		
		Promise.all([vindrApi.getToken()])
		.then((res) => {
			
			const dataRequests = [
				authApi.getUser()

			];
			return Promise.all(dataRequests);
		}).then((res)=>{
			var responses = res.map((response) => {
				if(response.json)
					return response.json();
				return response;
			});
			return Promise.all(responses);
		}).then(function(responses) {
			var user = responses[0];
			
			setUser(user);
			
//			myJson.map((item)=>{
//				//cleanup some newline characters,etc from the names
//				item.fullName = item.fullName.trim();
//				if(item.email)
//					item.email = item.email.trim();
//				//
//				//... other validation and cleanuup tasks can be added
//			})

			if(!filterCountry.length && user.settings.ownerFilters && user.settings.ownerFilters.country.length && countryComp.current){
				selectFilter("country", user.settings.ownerFilters.country, setFilterCountry)
				countryComp.current.setValue(user.settings.ownerFilters.country);
			}
			document.title = process.env.REACT_APP_DOC_TITLE;
			setPending(false);
		});

		
		
	};

	
	var selectFilter = (filter, opts, callback) => {
		
		//add filter to url
		setUrlParam(filter, opts.map(obj => obj.value).join(","));
		
		//we use a Set so to avoid repeat options
		callback(new Set(opts.map(obj => obj.value)));
		
		//update user settings
		saveFilter(filter, opts);
	};
	
	const searchNeedle = (item) => {
		
		if(needle.length < 3)
			return true;
		
		/* we use search now, therefor the >-1 condition, eventualy we can use regexp for boolean and search ranking*/
		return 	(item.fullName && item.fullName.match(new RegExp(needle, "i"))) || 
			(item.email && item.email.match(new RegExp(needle, "i"))) || 
			(item.phone && item.phone.match(new RegExp(needle, "i"))) || 
			(item.street && item.street.match(new RegExp(needle, "i"))) || 
			(item.projects && item.projects.length && item.projects.map(a => a.name).join(" ").match(new RegExp(needle, "i")));
	}
	

	useEffect(()=>{
		getData();
	},[])		

	var search = (a) => {
		
		if(a.target.value.length>2 || !a.target.value.length) {
			setUrlParam("search", a.target.value);
			setNeedle(a.target.value)
		}
	};
	function highlight(str, group1, group2) {
		return "<span class=bg-warning>"+str+"</span>";
	}
	const saveFilter = (filter, value)=>{
		
		if(user && user.userDetails && user.settings){
			if(!user.settings.ownerFilters)
				user.settings.ownerFilters = {};
			user.settings.ownerFilters[filter] = value;
			user.email = user.userDetails;

			vindrApi.updateSettings(user);
		}
		
	}
	const renderOwners = ()=> {

		if(data && data.length>0 ) {
			
			if(orderBy.length !== 0){
				/*
				 sort code here
				 eventualy it will be necessary to change this if asc and desc become options
				*/
				data.sort((a, b) => {
					if(!a[orderBy])
						return 1;
					if(!b[orderBy])
						return -1;
					return a[orderBy] && a[orderBy].toLowerCase().localeCompare(b[orderBy].toLowerCase());
				});
			}





			return data.map((item, index)=>{


				/* lets highlight the text users search, for usability */
				
				let phone = '';
				let street = '';
				let email = '';
				let projects = '';


				if(item.projects && item.projects.length)
					projects = item.projects.map((a) => {return (<Link to={"/pages/project/" + a.id}><Badge className="me-1" bg="primary text-white">{parse(a.name.replace(new RegExp(needle, "i"), highlight))}</Badge></Link>)})
				



				if(
					searchNeedle(item) && 
					(!filterCountry.size || filterCountry.has(item.country))
				){
					return (

						<Card key={index} className="card card-owner m-2">
							<Card.Header>
								<h6 className="card-title">
									{parse(item.fullName.replace(new RegExp(needle, "i"), highlight))} <Link className="me-5" title="Edit" to=""><i className="ri-pencil-line" /></Link>
									{projects}
								</h6>
							</Card.Header>
							<Card.Body>
								<Row>
									<Col xs="4">
										<div className="fw-bold">Email</div>
										<div>{item.email ? parse(item.email.replace(new RegExp(needle, "i"), highlight)) : ' '} &nbsp;</div>
									</Col>

									<Col xs="4">
										<div className="fw-bold">Phone</div>
										<div>{item.phone ? parse(item.phone.replace(new RegExp(needle, "i"), highlight)) : ' '} &nbsp;</div>
									</Col>
									<Col xs="4">
										<div className="fw-bold">Address</div>
										<div>
											{item.street ? parse(item.street.replace(new RegExp(needle, "i"), highlight)) : ' '}
											{item.zipcode ? ', '+parse(item.zipcode.replace(new RegExp(needle, "i"), highlight)) : ' '}
											{item.city ? ', '+parse(item.city.replace(new RegExp(needle, "i"), highlight)) : ' '} 
											&nbsp;
										</div>
									</Col>
								</Row>



							</Card.Body>
						</Card>
					)
				}
			});
		}
	}

	return (
		<React.Fragment>
			<div className="header">
			
				<div className="menu">
					<i className="ri-menu-2-fill"></i>
				</div>
				
				
				<div className="middle">
					

					<Link to="/" className="header-logo">Site Planner</Link>
					
				</div>
				<div className="logo">
					<img className="img-fluid d-none d-md-block brand-logo" src="/images/vindr_logo_blue.svg" alt="Vindr"/>
				</div>
				<div className="options">
						{user.userId && <UserMenu user={user} onUpdateUser={setUser} />}
						
				</div>
			</div>
			
			<div className="body dashboard2">
			
				<Sidebar />
				<div className="main owners p-4 p-lg-5">
					<Row>
						<Col xl>

							<Row className="g-3 pb-4">

								<Col xs="6">

									<SearchOwner searchHandler={(data, query)=>{setOwners(data); setNeedle(query)}} onSearchPending={(pending)=>{setPending(pending)}} keepResults />
								</Col>


								<Col xs="1" className="text-start pt-0 filter-wrp">

									<i role="button" className="ri-equalizer-line" onClick={(e)=>{setShowFilters(!showFilters); e.stopPropagation();}}></i>


									<Card onClick={(e)=>{e.stopPropagation();}} className={"projects-filter-panel shadow-sm "+(showFilters ? "d-block opacity-100" : "opacity-0")}>
										<Card.Body>
											<div className="g-3 pb-4">
												<div><b>Countries</b></div>
												<Filter ref={countryComp} options={Country.options} defaultValue={countrySel.map((a)=>{return {value:a, label:a};})} onChange={(a)=>{selectFilter("country", a, setFilterCountry)}} placeholder="All" isSearchable={false} isMulti />
											</div>

										</Card.Body>
									</Card>


								</Col>
								<Col xs="5" className="text-end pt-2"></Col>
								<Col xs="12">

									{
										Array.from(filterCountry).map((a, idx)=>{
											return (<span key={idx} className="filter-text d-inline-block p-1 px-2 my-1 me-4 rounded  border border-secondary-subtle bg-secondary-subtle">{a} <i role="button" onClick={()=>{countryComp.current.deSelect(a)}} className="ri-close-line"></i></span>)
										})

									}


								</Col>
							</Row>		

							<Row className="g-3">
							{pending ? <><div className="search-placeholder"><Spinner animation="border" variant="success" size="xl" /></div></> : renderOwners()}

							</Row>
						</Col>
					</Row>

				</div>
			</div>
			
		</React.Fragment>
	);
}
